export default 'survey'
